import { useTranslation } from "react-i18next";
import { LeafModal } from "../../../common/leaf/LeafModal/LeafModal";
import defaultContent from "../../../content/treeView";
import { AWARD_RANK_TO_COLOR } from "../drawNode/awardColors";
import "./TreeViewInfoKeyModal.scss";

interface TreeViewInfoKeyModalProps {
  open: boolean;
  onClose: () => void;
}

// Award ranks explained in the key, in display order — mirrors the legacy Lit
// acc-wc-view-info-key component's fixed aboAwardsArray.
const INFO_KEY_ROWS: { rank: number; labelKey: keyof typeof defaultContent.infoKey }[] = [
  { rank: 2020, labelKey: "platinumOrAbove" },
  { rank: 320, labelKey: "goldProducer" },
  { rank: 310, labelKey: "silverProducer" },
  { rank: 305, labelKey: "silverSponsor" },
];

export const TreeViewInfoKeyModal = ({ open, onClose }: TreeViewInfoKeyModalProps) => {
  const { t } = useTranslation(["treeView"]);

  return (
    <LeafModal
      open={open}
      onCloseCallbackFn={onClose}
      title={t("infoKey.title", defaultContent.infoKey.title)}
      id="tree-view-info-key-modal"
    >
      <div className="tree-view-info-key-modal">
        {INFO_KEY_ROWS.map(({ rank, labelKey }) => (
          <div className="tree-view-info-key-modal__row" key={rank}>
            <span className="tree-view-info-key-modal__label">
              {`${t(`infoKey.${labelKey}`, defaultContent.infoKey[labelKey])}`}
            </span>
            <span
              className="tree-view-info-key-modal__swatch"
              style={{ backgroundColor: AWARD_RANK_TO_COLOR[rank]?.bg }}
            />
          </div>
        ))}
        <div className="tree-view-info-key-modal__row" key="intl">
          <span className="tree-view-info-key-modal__label">
            {t("infoKey.internationalDownline", defaultContent.infoKey.internationalDownline)}
          </span>
          <span className="tree-view-info-key-modal__swatch tree-view-info-key-modal__swatch--intl" />
        </div>
      </div>
    </LeafModal>
  );
};
